export enum TrialStage {
  Classification = 1,
  IntensityRating = 2,
}
